export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          精彩预告
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">即将上线与热播中的精彩内容，先睹为快</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {/* Media 1 */}
          <div className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer">
            <div className="aspect-[2/3] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20with%20mysterious%20silhouette%20in%20rainy%20city%20at%20night%2C%20film%20noir%20aesthetic%2C%20warm%20neon%20and%20shadow%20contrast%2C%20dramatic%20mood%2C%20no%20text&width=400&height=600&seq=media-card-01&orientation=portrait"
                alt="暗夜追踪者第三季"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="text-xs font-semibold text-white bg-primary-500 px-2 py-1 rounded-md whitespace-nowrap">更新中</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent flex flex-col justify-end p-4">
                <h3 className="text-sm font-semibold text-white mb-1">暗夜追踪者</h3>
                <p className="text-xs text-foreground-300">第三季 · 悬疑犯罪</p>
              </div>
            </div>
          </div>

          {/* Media 2 */}
          <div className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer">
            <div className="aspect-[2/3] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Fantasy%20adventure%20movie%20poster%20style%20with%20ancient%20Chinese%20mythical%20creatures%20in%20clouds%2C%20warm%20golden%20and%20coral%20tones%2C%20epic%20cinematic%20illustration%2C%20no%20text&width=400&height=600&seq=media-card-02&orientation=portrait"
                alt="山海传说大电影"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="text-xs font-semibold text-white bg-accent-500 px-2 py-1 rounded-md whitespace-nowrap">热播中</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent flex flex-col justify-end p-4">
                <h3 className="text-sm font-semibold text-white mb-1">山海传说</h3>
                <p className="text-xs text-foreground-300">大电影 · 奇幻动画</p>
              </div>
            </div>
          </div>

          {/* Media 3 */}
          <div className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer">
            <div className="aspect-[2/3] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Romantic%20drama%20poster%20style%20with%20couple%20silhouette%20against%20sunset%20sky%2C%20warm%20golden%20hour%20lighting%2C%20tender%20emotional%20atmosphere%2C%20film%20poster%20aesthetic%2C%20no%20text&width=400&height=600&seq=media-card-03&orientation=portrait"
                alt="星海恋歌"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="text-xs font-semibold text-white bg-secondary-500 px-2 py-1 rounded-md whitespace-nowrap">新上线</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent flex flex-col justify-end p-4">
                <h3 className="text-sm font-semibold text-white mb-1">星海恋歌</h3>
                <p className="text-xs text-foreground-300">浪漫爱情 · 都市剧</p>
              </div>
            </div>
          </div>

          {/* Media 4 */}
          <div className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer">
            <div className="aspect-[2/3] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20style%20with%20majestic%20mountain%20landscape%20and%20wildlife%2C%20warm%20earth%20tones%2C%20cinematic%20wide%20shot%20composition%2C%20epic%20scale%2C%20no%20text&width=400&height=600&seq=media-card-04&orientation=portrait"
                alt="地球脉动第三季"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="text-xs font-semibold text-white bg-primary-500 px-2 py-1 rounded-md whitespace-nowrap">推荐</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent flex flex-col justify-end p-4">
                <h3 className="text-sm font-semibold text-white mb-1">地球脉动</h3>
                <p className="text-xs text-foreground-300">第三季 · BBC纪录片</p>
              </div>
            </div>
          </div>

          {/* Media 5 */}
          <div className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer">
            <div className="aspect-[2/3] relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Variety%20show%20poster%20style%20with%20colorful%20confetti%20and%20stage%20lights%2C%20energetic%20fun%20atmosphere%2C%20warm%20vibrant%20coral%20and%20gold%20tones%2C%20entertainment%20show%20aesthetic%2C%20no%20text&width=400&height=600&seq=media-card-05&orientation=portrait"
                alt="欢乐挑战赛第七季"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3">
                <span className="text-xs font-semibold text-white bg-accent-500 px-2 py-1 rounded-md whitespace-nowrap">热门</span>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent flex flex-col justify-end p-4">
                <h3 className="text-sm font-semibold text-white mb-1">欢乐挑战赛</h3>
                <p className="text-xs text-foreground-300">第七季 · 户外综艺</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}